// Generate 50 mock posts with unique images and dynamic dates
export const allPosts = Array.from({ length: 50 }, (_, i) => {
    const baseId = i + 50; // Ensure unique image IDs
    return {
        id: i + 1,
        title: `Post Title ${i + 1}`,
        excerpt: `This is a short description for post ${i + 1}.`,
        featuredImage: i === 1? `https://videos.pexels.com/video-files/30698031/13135569_1920_1080_30fps.mp4`: `https://picsum.photos/id/${baseId}/1600/1200`,
        images: [
            `https://picsum.photos/id/${baseId + 1}/1600/1200`,
            `https://picsum.photos/id/${baseId + 2}/1600/1200`,
            `https://picsum.photos/id/${baseId + 3}/1600/1200`
        ],
        link: "/post/" + (i + 1),
        socialTags: ["Social", "Marketing", "Tips"],
        datePublished: new Date(Date.now() - i * 86400000).toISOString().split("T")[0], // Dynamic past dates
    };
});

// Function to fetch mock posts with pagination
export const fetchMockPosts = async (page = 1, limit = 5) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            const start = (page - 1) * limit;
            const end = start + limit;
            resolve(allPosts.slice(start, end));
        }, 1000); // Simulate network delay
    });
};
